import { Component, EventEmitter, Input, Output, OnChanges } from '@angular/core';
import { Asset } from '@shared/models/asset.model';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { filter } from 'rxjs/operators';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { AssetType, AssetData } from '@shared/models';
import { FileManagerComponent } from '@shared/components/file-manager/file-manager.component';

@Component({
  selector: 'room-selector',
  templateUrl: './room-selector.component.html',
  styleUrls: ['./room-selector.component.scss']
})
export class RoomSelectorComponent implements OnChanges {
  @Input() current_room: Asset | null;
  @Input() childrenClass: string;
  @Output() roomChange = new EventEmitter<Asset>();
  roomType = AssetType.r3D;

  constructor(
    private _dialog: MatDialog,
    private _courseApiService: CoursesAPIService,
  ) { }

  ngOnChanges(): void {
    if (this.current_room == null) {
      // if there is no room, we default to a 3D room
        this.roomType = AssetType.r3D;
    } else {
      this.roomType = this.current_room.type;
    }
  }

  getAssetToShow(): Asset | null
  {
    return this.current_room && this.isExpectedType() ? this.current_room : null;
  }

  isExpectedType(): boolean {
    return this.current_room.type === this.roomType;
  }

  getTypeName(type: string): string {
    return AssetData.get(type).typeName;
  }

  onOpenRoomManager(): void {
    if (this.roomType === AssetType.r3D) {
      this._dialog.open(
        FileManagerComponent,
        {
          id: 'room-manager',
          data: { 
            title: 'My Rooms',
            type: AssetType.r3D,
            openOnTab: -1
          },
          panelClass: [this.childrenClass],
        })
        .afterClosed()
        .subscribe(asset => {
          if (asset) {
            this.current_room = asset;
            this.roomChange.emit(this.current_room);
          }
        });
    } else if (this.roomType === AssetType.i360) {
      this._dialog.open(FileManagerComponent, {
        data: {
          title: 'Add 360° image Room',
          type: AssetType.i360
        },
        panelClass: [this.childrenClass],
      }).afterClosed().pipe(
        filter(a => a)
      ).subscribe(asset => {
        this.current_room = asset;
        this.roomChange.emit(this.current_room);
      });
    }
  }

}
